import React, { useState, useEffect } from 'react';
import './EnquiryForm.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const EnquiryForm = ({ setShowForm }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    state: '',
    city: '',
    course: '',
    work_experience: ''
  });

  const [errors, setErrors] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const [visibleCount, setVisibleCount] = useState(0);
  const fullTitle =  "DOCUMENT ACCESS: ENQUIRY FORM";

  useEffect(() => {
    let i = 0;
    const timer = setInterval(() => {
      setDisplayText(fullTitle.substring(0, i));
      i++;
      if (i > fullTitle.length) {
        clearInterval(timer);
        startFieldSequence();
      }
    }, 40);
    return () => clearInterval(timer);
  }, []);

  const startFieldSequence = () => {
    let count = 0;
    const interval = setInterval(() => {
      count++;
      setVisibleCount(count);
      if (count >= 5) clearInterval(interval);
    }, 200);
  };

  const calculateProgress = () => {
    const filledFields = Object.values(formData).filter(val => val !== '').length;
    return Math.round((filledFields / 7) * 100);
  };

  const states = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Other"
  ];

  const courses = [ "MCA", "Integrated MCA", "MCA For Working Professionals", "Ph.D"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.name) tempErrors.name = "ID_REQUIRED";
    if (!formData.email) tempErrors.email = "EMAIL_REQUIRED";
    if (!formData.phone) tempErrors.phone = "PHONE_REQUIRED";
    if (!formData.state) tempErrors.state = "STATE_REQUIRED";
    if (!formData.city) tempErrors.city = "CITY_REQUIRED";
    if (!formData.course) tempErrors.course = "TYPE_REQUIRED";
    if (!formData.work_experience) tempErrors.work_experience = "HIST_REQUIRED";
    
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setIsProcessing(true);
      try {
        const response = await fetch(`${API_URL}/enquiry-data`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        });
        if (response.ok) {
          setIsSubmitted(true);
          setTimeout(() => setShowForm(false), 3000);
        } else {
          alert("TRANSMISSION FAILED");
        }
      } catch (error) {
        alert("NETWORK ERROR");
      }
      setIsProcessing(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("tf-portal-container")) {
      setShowForm(false);
    }
  };

  const progress = calculateProgress();

  if (isSubmitted) {
    return (
      <div className="tf-portal-container">
        <div className="tf-moving-grid"></div>
        <div className="tf-scanlines"></div>
        <div className="tf-glass-frame tf-success-frame">
          <div className="tf-success-content">
            <div className="tf-success-icon">✓</div>
            <div className="tf-success-title">TRANSMISSION COMPLETE</div>
            <div className="tf-success-message">Thank you! Your form has been submitted successfully.</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tf-portal-container" onClick={handleOverlayClick}>
      <div className="tf-moving-grid"></div>
      <div className="tf-scanlines"></div>
      
      <div className={`tf-glass-frame ${isProcessing ? 'tf-syncing' : ''}`}>
        
        <div className="tf-progress-container">
          <div className="tf-progress-label">
            <span>ENCRYPTION: {progress}%</span>
            <span>{progress === 100 ? 'UPLINK_READY' : 'PROCESSING...'}</span>
          </div>
          <div className="tf-progress-bar-bg">
            <div className="tf-progress-fill" style={{ width: `${progress}%` }}></div>
          </div>
        </div>

        <div className="tf-header-wrapper">
          <span className="tf-main-title">
            {displayText}
            <span className="tf-cursor">_</span>
          </span>
          <span className="tf-sub-title">* INITIALIZING SECURE LAB DATA SEQUENCE...</span>
        </div>

        <div className="tf-grid-layout">
          <div className={`tf-input-group tf-fade-in-field ${visibleCount >= 1 ? 'visible' : ''}`}>
            <span className="tf-label">USER IDENTITY</span>
            <input 
              name="name" 
              type="text" 
              placeholder="FULL NAME" 
              className={`tf-field-input ${errors.name ? 'tf-input-err' : ''}`} 
              onChange={handleChange}
              value={formData.name}
            />
            {errors.name && <span className="tf-err-msg">{errors.name}</span>}
          </div>

          <div className={`tf-input-group tf-fade-in-field ${visibleCount >= 2 ? 'visible' : ''}`}>
            <span className="tf-label">EMAIL ADDRESS</span>
            <input 
              name="email" 
              type="email" 
              placeholder="EMAIL" 
              className={`tf-field-input ${errors.email ? 'tf-input-err' : ''}`} 
              onChange={handleChange}
              value={formData.email}
            />
            {errors.email && <span className="tf-err-msg">{errors.email}</span>}
          </div>

          <div className={`tf-input-group tf-fade-in-field ${visibleCount >= 2 ? 'visible' : ''}`}>
            <span className="tf-label">PHONE NUMBER</span>
            <input 
              name="phone" 
              type="tel" 
              placeholder="PHONE" 
              className={`tf-field-input ${errors.phone ? 'tf-input-err' : ''}`} 
              onChange={handleChange}
              value={formData.phone}
            />
            {errors.phone && <span className="tf-err-msg">{errors.phone}</span>}
          </div>

          <div className={`tf-input-group tf-fade-in-field ${visibleCount >= 3 ? 'visible' : ''}`}>
            <span className="tf-label">STATE</span>
            <select 
              name="state" 
              className={`tf-field-select ${errors.state ? 'tf-input-err' : ''}`} 
              onChange={handleChange}
              value={formData.state}
            >
              <option value="">-- SELECT STATE --</option>
              {states.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
            {errors.state && <span className="tf-err-msg">{errors.state}</span>}
          </div>

          <div className={`tf-input-group tf-fade-in-field ${visibleCount >= 3 ? 'visible' : ''}`}>
            <span className="tf-label">CITY</span>
            <input 
              name="city" 
              type="text" 
              placeholder="CITY" 
              className={`tf-field-input ${errors.city ? 'tf-input-err' : ''}`} 
              onChange={handleChange}
              value={formData.city}
            />
            {errors.city && <span className="tf-err-msg">{errors.city}</span>}
          </div>

          <div className={`tf-input-group tf-fade-in-field ${visibleCount >= 4 ? 'visible' : ''}`}>
            <span className="tf-label">SPECIALIZATION</span>
            <select 
              name="course" 
              className={`tf-field-select ${errors.course ? 'tf-input-err' : ''}`} 
              onChange={handleChange}
              value={formData.course}
            >
              <option value="">-- SELECT MODULE --</option>
              {courses.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            {errors.course && <span className="tf-err-msg">{errors.course}</span>}
          </div>
        </div>

        <div className={`tf-exp-section tf-fade-in-field ${visibleCount >= 5 ? 'visible' : ''}`}>
          <span className="tf-label">HISTORY (EXP)</span>
          <div className="tf-radio-cluster">
            {['Fresher', '1-2 Years', '3-5 Years', '5+ Years'].map((exp, idx) => (
              <label key={idx} className="tf-radio-item">
                <input 
                  type="radio" 
                  name="work_experience" 
                  value={exp} 
                  className="tf-radio-dot" 
                  onChange={handleChange}
                  checked={formData.work_experience === exp}
                />
                <span className="tf-radio-label">{exp}</span>
              </label>
            ))}
          </div>
          {errors.work_experience && <span className="tf-err-msg">{errors.work_experience}</span>}
        </div>

        <div className={`tf-button-cluster tf-fade-in-field ${visibleCount >= 5 ? 'visible' : ''}`}>
          <button className="tf-btn-submit tf-glitch-hover" onClick={handleSubmit} disabled={isProcessing}>
            <span className="tf-btn-text">{isProcessing ? "UPLOADING..." : "[ SUBMIT DATA ]"}</span>
          </button>
          <button className="tf-btn-cancel" onClick={() => setShowForm(false)}>
            <span className="tf-btn-text">[ ABORT ]</span>
          </button>
        </div>

      </div>
    </div>
  );
};

export default EnquiryForm;
